import { ReactElement, ReactNode, useState } from 'react';

import { BoxProps } from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import ButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase';

import Tooltip from '../../../../../components/Tooltip';

export interface TileProps extends ButtonBaseProps<'div'> {
  title: string;
  gridArea: string;
  backgroundColor: string;
  sx?: BoxProps['sx'];
  children: ReactNode;
}

export default function Tile({
  title,
  gridArea,
  backgroundColor,
  sx = {},
  children,
  ...props
}: TileProps): ReactElement {
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState<null | number>(null);
  const [hovered, setHovered] = useState(false);
  return (
    <Tooltip title={title} open={open}>
      <ButtonBase
        sx={{
          gridArea,
          background: backgroundColor,
          display: 'flex',
          position: 'relative',
          cursor: 'pointer',
          '& .MuiTouchRipple-root': {
            color: 'white',
          },
          color: 'black',
          ...sx,
        }}
        component={Paper}
        focusRipple
        onMouseOver={() => {
          setHovered(true);
          setTimer(
            window.setTimeout(() => {
              setOpen(true);
              setTimer(null);
            }, 750)
          );
        }}
        onMouseOut={() => {
          setHovered(false);
          if (timer !== null) window.clearTimeout(timer);
          setTimer(null);
          setOpen(false);
        }}
        onMouseLeave={() => {
          setHovered(false);
          if (timer !== null) window.clearTimeout(timer);
          setTimer(null);
          setOpen(false);
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        elevation={hovered ? 7 : 1}
      >
        {children}
      </ButtonBase>
    </Tooltip>
  );
}
